import { PieChart, Pie, Cell, Tooltip } from "recharts";
import React, { useEffect, useState } from "react";
import { useLazyGetToiletryDistributionQuery } from "../../../../services/Api";
import LoaderSpiner from "../../../../components/loaderSpiner";

const COLORS = ["#3D5673", "#5D733C", "#F2C94C"];

export default function TechItemDistribution() {
  const [trigger, { data, isLoading, error }] =
    useLazyGetToiletryDistributionQuery();
  const [chartData, setChartData] = useState([]);
  const [totalPercentage, setTotalPercentage] = useState(0);

  useEffect(() => {
    trigger()
      .unwrap()
      .then((response) => {

        const packingStats = response?.data || [];
        const formattedData = packingStats.map((item) => ({
          name: item.label,
          value: parseFloat(item.percentage),
        }));

        setChartData(formattedData);

        if (formattedData.length > 0) {
          setTotalPercentage(formattedData[0].value);
        }
      })
      .catch((err) => {
      });
  }, [trigger]);

  if (isLoading) return <LoaderSpiner />;
  if (error) return <p>Error loading data. Please try again later.</p>;

  return (
    <div className="bg-lightgreen p-6 rounded-[1.75rem] h-full">
      <h3 className="mb-4 font-['Roboto_Mono'] text-lg font-bold">
        Toiletry Distribution
      </h3>
      <div className="flex flex-col justify-center items-center relative">
        <PieChart width={200} height={200}>
          <Pie
            data={chartData}
            innerRadius={60}
            outerRadius={80}
            paddingAngle={0}
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            wrapperStyle={{
              fontSize: "14px",
              backgroundColor: "#000",
              color: "#fff",
            }}
            formatter={(value) => `${value}%`}
          />
        </PieChart>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-[50%] flex justify-center items-center">
          <p className="text-2xl font-bold">{totalPercentage}%</p>
        </div>
      </div>

      {/* Legend Section */}
      <div className="flex justify-center flex-col  mt-1 font-['Quicksand'] text-sm font-medium">
        {chartData.map((entry, index) => (
          <div
            key={entry.name}
            className="flex items-center justify-center w-full gap-2"
          >
            <div
              className="w-2 h-2 rounded-full shrink-0"
              style={{ backgroundColor: COLORS[index % COLORS.length] }}
            ></div>
            <span className="md:text-sm text-xs">{entry.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}